
































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Locales } from "@/i18n/locales";

@Component({
  components: {},
})
export default class InternalDashboardComponent extends Vue {
  actionHeaders: Array<object> = [
    { text: "Title", value: "Application", sortable: false },
    { text: "Status", value: "Status", sortable: false },
    { text: "Due In Days", value: "DueBy", sortable: false },
    { text: "Type", value: "Type", sortable: false },
  ];

  deadlineHeaders: Array<object> = [
    { text: "Title", value: "Application", sortable: false },
    { text: "Status", value: "Status", sortable: false },
    { text: "Due In Days", value: "DueBy", sortable: false },
    { text: "Type", value: "Type", sortable: false },
  ];

  summaryHeaders: Array<object> = [
    { text: "Status", value: "Name", sortable: false },
    { text: "Count", value: "Count", sortable: false },
  ];

  activityHeaders: Array<object> = [
    { text: "Activity", value: "activity", sortable: false },
    // { text: "Url", value: "url", sortable: false },
    // { text: "Status Code", value: "statusCode", sortable: false },
    // { text: "Role", value: "role", sortable: false },
    // { text: "IP Address", value: "ipAddress", sortable: false },
  ];

  documentHeaders: Array<object> = [
    { text: "Tag", value: "TagName", sortable: false },
    { text: "Section", value: "Section", sortable: false },
    { text: "File", value: "FileName", sortable: false },
  ];

  actionItems: any = [];
  deadlineItems: any = [];
  summaryData: any = [];
  activityData: any = [];
  documentData: any = [];

  mounted() {
    this.getDashboard();
  }

  getDashboard() {
    this.$services.gmsdashboard.getInternalDashboard().then((resp) => {
      this.actionItems = resp.data.ActionItems;
      this.deadlineItems = resp.data.DeadlineItems;
      this.summaryData = resp.data.SummaryItems;
      this.activityData = resp.data.Activities;
      this.documentData = resp.data.Documents;
    });
  }
}
